import { DataService } from "base/services";
import { useAccountStore } from "base/stores";

import { getApiBaseUrl } from "../utils/service.utils.js";

const USER_SERVICE = "user";

export const ProfileService = {
  getProfile() {
    const accountId = useAccountStore.getState()._id;
    return DataService.get(`/user/2/${accountId}/me`);
  },

  saveProfile(updatedData) {
    const accountId = useAccountStore.getState()._id;
    return DataService.update(`/user/2/${accountId}/me`, {
      data: updatedData
    });
  },

  getUserProfile(userId) {
    let url = getApiBaseUrl(USER_SERVICE);
    return DataService.get(`${url}/${userId}`);
  },

  getProfileSettings() {
    const accountId = useAccountStore.getState()._id;
    return DataService.get(`/user/2/${accountId}/me/settings`);
  },

  saveProfileSettings(updatedData) {
    const accountId = useAccountStore.getState()._id;
    return DataService.update(`/user/2/${accountId}/me/settings`, {
      data: updatedData
    });
  }
};
